<template>
    <v-expansion-panels multiple v-for="v in pcEntities" v-bind:key="v.id">
        <template v-if="(v as any)._totalApplyDamage > 0">
            <v-expansion-panel>
                <v-expansion-panel-title>
                    <v-sheet>
                        {{ prettyEntityName(v) }} {{ (v as any)._totalApplyDamage.toFixed(0) }} {{ (100 * (v as any)._totalApplyDamage /
                            allApplyDamage).toFixed(1) }}%
                    </v-sheet>

                </v-expansion-panel-title>
                <v-expansion-panel-text class="pa-3">
                    <v-sheet
                        v-for="targetStat in Object.values((v as any).aggregatedStats || {}).sort((a: any, b: any) => b.totalDamage - a.totalDamage)"
                        v-bind:key="(targetStat as any).targetId" width="100%" class="mb-4">
                        <!-- 이름 -->
                        <v-sheet width="100%">
                            {{ prettyEntityName(entityMap[(targetStat as any).targetId]) || (targetStat as any).targetId }} {{
                                (targetStat as any).totalDamage.toFixed(0) }} {{
                                (100 * (targetStat as any).totalDamage / (v as any)._totalApplyDamage).toFixed(1) }}%
                        </v-sheet>

                        <!-- 막대 -->
                        <v-sheet width="100%" height="16">
                            <v-sheet :color="getMabiNameColor(prettyEntityName(entityMap[(targetStat as any).targetId]) || (targetStat as any).targetId)"
                                height="100%"
                                :width="`${Math.round(100 * (targetStat as any).totalDamage / (v as any)._totalApplyDamage).toFixed(0)}%`"
                                class="rounded-xl">
                            </v-sheet>
                        </v-sheet>
                    </v-sheet>
                </v-expansion-panel-text>
            </v-expansion-panel>
            <!-- 막대 -->
            <v-sheet width="100%" height="16">
                <v-sheet :color="getMabiNameColor(prettyEntityName(v)!)" height="100%"
                    :width="`${Math.round(100 * (v as any)._totalApplyDamage / allApplyDamage).toFixed(0)}%`" class="rounded-xl">
                </v-sheet>
            </v-sheet>
        </template>

    </v-expansion-panels>
</template>

<script lang="ts">
import { defineComponent, inject, computed } from "vue";

import { getMabiNameColor } from '@/util';
import { ActorManager, BaseActor, GroupActor, EntityActor } from '@/eventActor';

export default defineComponent({
    setup() {
        const isLoading = inject('isLoading');
        const region = inject('region');
        const raceNameMap = inject('raceNameMap') as any;
        const skillNameMap = inject('skillNameMap');
        const actorManager = inject('actorManager') as any;
        const appEvent = inject('appEvent') as any;

        const entityMap = computed(() => {
            appEvent.value;
            actorManager.value.liveUpdate.value;
            return actorManager.value.entityMap as Record<string, EntityActor>;
        });

        const pcEntities = computed(() =>
            Object.values(entityMap.value).filter(v => v.isPC).sort((a: any, b: any) => (b._totalApplyDamage || 0) - (a._totalApplyDamage || 0)));

        const allApplyDamage = computed(() =>
            pcEntities.value.reduce((acc, v: any) => acc + (v._totalApplyDamage || 0), 0));

        const prettyEntityName = (entity?: BaseActor) => {
            if (!entity) return undefined;
            if (ActorManager.pcRaceSet.has(entity.raceId)) return entity.name;
            const raceName = raceNameMap.value[entity.raceId] || `unknownRace:${entity.raceId}`;
            if (entity instanceof GroupActor) return raceName;
            if (entity.name[0] >= '0' && entity.name[0] <= '9') return `${raceName} (${entity.name.slice(-4)})`;
            return entity.name;
        }

        return {
            isLoading,
            region,
            pcEntities,
            allApplyDamage,
            skillNameMap,
            entityMap,
            getMabiNameColor,
            prettyEntityName,
        }
    }
});

</script>